import styled from 'styled-components'
import ReactSlider from 'react-slider'
import { ReactNode, useState } from 'react'

export const Slider = ({
  label,
  subline,
  info,
  unit,
  current = 0,
  onChange,
  range = [0, 100],
  step = 1,
  stateProp,
}: {
  label?: string
  subline?: string | JSX.Element
  info?: string
  unit?: string
  current?: number
  range?: number[]
  step?: number
  onChange: (id: string, e: number) => void
  stateProp: string
}) => {
  const [value, setValue] = useState(current)
  const [hasFocus, setHasFocus] = useState(false)
  const [hovered, setHovered] = useState(false)

  function handleChange(e: number) {
    onChange(stateProp, e)
    setValue(e)
  }
  return (
    <SliderRoot
      show={hovered}
      onPointerMove={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
    >
      <LabelRow>
        {label && <Label>{label}</Label>}
        {subline && <SubLine>{subline}</SubLine>}
      </LabelRow>
      <ValueDisplayInput
        value={
          hasFocus
            ? value
            : (value >= range[1] ? '>' : '') +
              formatNumber(value) +
              (unit || '')
        }
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        onChange={(e) => {
          const val = Math.min(
            range[1],
            isNaN(+e.target.value) ? 0 : +e.target.value
          )
          setValue(val)
          onChange(stateProp, parseInt(e.target.value))
        }}
      />

      <SliderContainer>
        <ReactSlider
          className='horizontal-slider'
          thumbClassName='example-thumb'
          trackClassName='example-track'
          value={value}
          min={range[0]}
          max={range[1]}
          step={step}
          onChange={(e: number) => {
            handleChange(e)
          }}
          renderThumb={(props, state) => <div {...props}></div>}
        />
      </SliderContainer>
      {info && <Info show={hovered}>{info}</Info>}
    </SliderRoot>
  )
}
function formatNumber(n: number) {
  if (n < 10000) return n
  return n.toLocaleString('ch-DE').replaceAll('.', "'")
}

const LabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  width: 100%;
  img {
    height: 22px;
    width: 22px;
    flex: 0 0 22px;
    margin-right: 8px;
  }
`

const SubLine = styled.div`
  font-size: 12px;
  color: var(--text-color);
  flex: 0 0 100%;
  line-height: 1.4em;
  /* max-width: 300px; */

  min-height: 4.5em;
  user-select: none;
  @media screen and (max-width: 712px) {
    /* user-select: unset; */
    pointer-events: all;
  }
`
const Info = styled.div<{ show: boolean }>`
  font-size: 12px;
  color: var(--slider-sub-color);
  flex: 0 0 100%;
  line-height: 1.4em;
  /* max-width: 300px; */
  margin-bottom: ${(props) => (props.show ? '10px' : 0)};
  transition: max-height 0.2s ease, opacity 0.2s ease 0.05s;
  opacity: ${(props) => (props.show ? 1 : 0)};
  padding: 15px;
  max-height: ${(props) => (props.show ? '100px' : '0')};
  overflow: hidden;
  position: absolute;
  top: 100%;
  left: 0px;
  z-index: 10;
  background-color: var(--site-background);
  -webkit-box-shadow: ${(props) =>
    props.show ? '0px 5px 4px 2px rgba(0,0,0,0.1);' : undefined};
  box-shadow: ${(props) =>
    props.show ? '0px 5px 4px 2px rgba(0,0,0,0.1);' : undefined};

  @media screen and (max-width: 712px) {
    margin-top: ${(props) => (props.show ? '0px' : 0)};
    padding: ${(props) => (props.show ? '10px' : 0)};
  }
`

const Label = styled.label`
  display: block;
  line-height: 1.4em;
  font-size: 18px;
  letter-spacing: 0.25px;
  color: var(--gray-1);
  padding-bottom: 4px;
  width: 100%;
  flex: 0 0 100%;
  font-weight: 400;
  color: var(--text-color);
  user-select: none;
  @media screen and (max-width: 712px) {
    font-size: 15px;
  }
`

const SliderRoot = styled.div<{ show: boolean }>`
  position: relative;
  display: flex;
  box-sizing: border-box;
  flex: 0 0 calc(50% - 15px);
  width: 100%;
  text-align: left;
  padding-top: 4px;
  margin-bottom: 20px;
  display: flex;
  /* padding-bottom: 15px; */
  flex-wrap: wrap;
  /* border: 1px solid #f00; */
  padding: 15px;
  -webkit-box-shadow: ${(props) =>
    props.show ? '0px 5px 4px 2px rgba(0,0,0,0.1);' : undefined};
  box-shadow: ${(props) =>
    props.show ? '0px 5px 4px 2px rgba(0,0,0,0.1);' : undefined};

  @media screen and (max-width: 712px) {
    flex: 0 0 calc(100% + 20px);
    margin-left: -10px;
    &:not(:first-of-type) {
      border-top: 1px solid var(--gray-4);
    }
  }
  .horizontal-slider {
    max-width: 100%;
    max-width: calc(100% - 0px);
    pointer-events: none;
    &:hover {
      cursor: pointer;
    }
  }
  .example-track,
  .example-track-0,
  .example-track-1 {
    display: inline-block;
    height: 10px;
    background-color: var(--gray-5);
    border: 1px solid var(--gray-4);
    top: -8px;
    border-radius: 4px;
    pointer-events: all;
  }
  .example-thumb {
    overflow: hidden;
    cursor: pointer;
    background-color: var(--site-background);
    border: 1px solid var(--text-color);
    color: transparent;

    top: -22px;
    width: 20px;
    height: 35px;
    border-radius: 8px;
    outline: none;
    pointer-events: all;
    &:hover {
      background-color: var(--yellow-main);

      -webkit-box-shadow: 0px 0px 3px 5px rgba(0, 0, 0, 0.21);
      box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.4);
    }
  }
`

const ValueDisplayInput = styled.input`
  border: 0;
  text-align: center;
  flex: 0 0 100px;
  max-width: 95px;
  min-height: 30px;
  display: flex;
  align-items: center;
  padding: 5px;
  justify-content: center;
  font-size: 13px;
  background-color: var(--yellow-main);
  color: var(--brandblue-main);
  padding: 2px 5px;
  margin: 0;
  margin-top: 10px;
  margin-right: 5px;
  @media screen and (max-width: 712px) {
    margin-top: 4px;
    font-size: 16px;
  }
`
const SliderContainer = styled.div.attrs({ className: 'SliderContainer' })`
  flex: 0 0 calc(100% - 110px);
  margin-top: 10px;
  padding-top: 20px;
  margin-bottom: 20px;
  @media screen and (max-width: 712px) {
    margin-top: 4px;
  }
`
